export default $client => ({
  create(props) {
    return $client.post('feedback', {
      phone: props.phone,
      email: props.email,
      comment: props.comment
    })
  }
})
